import { Component, Input, OnInit } from '@angular/core';
import {
  AggregatedPlaylistSchemaDTO,
  BookedMediumGroupAggregationGroupDTO,
  MediumGroupDTO,
  PublicMediumDTO,
  TemplateDataSetDTO,
} from '../../../services/api/api';
import { ModalNavigationComponent } from '../../../services/gui/modal/modal-navigation-component';
import { ModalNavigationService } from '../../../services/gui/modal/modal-navigation.service';
@Component({
  selector: 'sb-comp-aggregated-playlist-schema',
  templateUrl: './aggregated-playlist-schema.component.html',
  styleUrls: ['./aggregated-playlist-schema.component.scss'],
  standalone: false,
})
export class AggregatedPlaylistSchemaComponent implements OnInit, ModalNavigationComponent {
  @Input() playlist: AggregatedPlaylistSchemaDTO;
  isInModalContext: boolean;

  mediaMap: Map<number, PublicMediumDTO>;
  mediumGroupMap: Map<number, MediumGroupDTO>;
  templateDataSetMap: Map<number, TemplateDataSetDTO>;
  bookedMediumGroups: BookedMediumGroupAggregationGroupDTO[];

  loading: boolean;

  constructor(private modalNavigationService: ModalNavigationService) {
    this.bookedMediumGroups = null;
    this.loading = true;
    this.playlist = null;
    this.mediaMap = new Map<number, PublicMediumDTO>();
    this.mediumGroupMap = new Map<number, MediumGroupDTO>();
    this.templateDataSetMap = new Map<number, TemplateDataSetDTO>();
  }

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.playlist = this.modalNavigationService.getCurrentNavigation().data.playlistScheme;
    }
    this.bookedMediumGroups = this.playlist.groups as BookedMediumGroupAggregationGroupDTO[];
    if (this.bookedMediumGroups) {
      for (const bookedMediumGroup of this.bookedMediumGroups) {
        if (bookedMediumGroup.id?.templateDataSet) {
          this.templateDataSetMap.set(bookedMediumGroup.id.templateDataSet, bookedMediumGroup.templateDataSet);
        }
        if (bookedMediumGroup.id?.mediumGroup) {
          this.mediumGroupMap.set(bookedMediumGroup.id.mediumGroup, bookedMediumGroup.mediumGroup);
        } else {
          bookedMediumGroup.media.forEach(medium => this.mediaMap.set(medium.id, medium));
        }
      }
    }
  }

  /*
  showBookingSet(setIndex: number | undefined) {
    if (setIndex == null) {
      return;
    }
    if (!this.isInModalContext) {
      this.modalService
        .showNavigationModal({
          entryComponent: { value: TargetedBookingSetComponent, data: { bookingSet: this.playlist.targetedBookings[setIndex] } },
          title: this.translate.instant('lang.globals.bookingSet') + ' ' + setIndex,
          icon: 'targeting',
          modalOptions: { size: 'lg' },
        })
        .then(() => {})
        .catch(() => {});
    } else {
      // already in Modal
      this.modalNavigationService.navigate(TargetedBookingSetComponent, { bookingSet: this.playlist.targetedBookings[setIndex] });
    }
  }

   */
}
